import React, { Component, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Label, Button, Alert, Form,
         Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Control, Form as ReduxForm } from 'react-redux-form';
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { CustomSelect, CustomListSelect, unique_values, sort_by } from './Functions';
import { RenderVirtualTable } from './TableComponent';
import { PiePlot } from './PlotComponent';
import { port_metrics_compar_actions } from '../redux/ActionType';
import { CSVLink } from "react-csv";
import { postRequest } from '../redux/ActionCreators';
import { Auth } from 'aws-amplify';

// import 'rsuite/dist/styles/rsuite-default.css';
const mapStateToProps = state => {
  return {
    port_alloc_compar:state.port_alloc_compar,
    compar_params: state.compar_params,
    user_wm: state.user_wm,
    port_metrics_compar: state.port_metrics_compar,
    port_groups: state.port_groups
  };
};

class PortCompar extends Component {
    constructor(props){
        super(props);
        this.state = {
            msg:null,
            show_msg:true,
            msg_report:null,
            loading_groups:false,
            gen_report:false,
            generating_report:false
        };
        this.runComparMetrics = this.runComparMetrics.bind(this);
        this.loadGroups = this.loadGroups.bind(this);
        this.openReportModal = this.openReportModal.bind(this);
        this.genReport = this.genReport.bind(this);
        this.queryAllocation = this.queryAllocation.bind(this);
    }
    // }
    async loadGroups(){
      this.setState({loading_groups:true});
      try {
        const userInfo = await Auth.currentUserInfo() //`${(await Auth.currentUserInfo()).username}`;
        const query_str = this.props.user_wm.data.role==1 ? `SELECT PortId, GroupId FROM PortfolioGroups` :
                          `SELECT pg.PortId, pg.GroupId FROM PortfolioGroups as pg JOIN UserGroups as ug ON pg.GroupId=ug.GroupId WHERE ug.Username='${userInfo.username.split("@")[0]}'`;
        const groups = await postRequest({
            database:'wmdb',
            query_string:query_str
            },'query_database');
        if (groups.data){
          await this.props.changeModel('port_groups', groups.data);
        } else {
          this.setState({msg:"Usuario no tiene grupos de portafolios asociados."});
        }
        this.setState({loading_groups:false});
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({loading_groups:false});
      }
    }

    async queryAllocation(){
      if (this.props.compar_params.port_names.length==0) {
        this.setState({msg:'Seleccionar al menos 1 portafolio.'});
      } else {
        this.setState({loading_allocation:true});
        try {
          const ports_alloc = await postRequest({
            port_id:this.props.compar_params.port_names, 
            last_update:false,
            res_url:false,
            own_only:this.props.user_wm.data?.role==3 ? true : false,
            port_groups:this.props.user_wm.data?.port_groups
          }, 'port_saa');
          this.props.changeModel("port_alloc_compar", ports_alloc.data);
        this.setState({loading_allocation:false});
        } catch(error) {
          this.setState({
            msg:`Error consultado portafolio (${error.message}).`,
            loading_allocation:false
          });
          return;
        }
      }
    }
  
    async openReportModal(){
      if (this.props.compar_params.port_names.length==0) {
        this.setState({msg:'Seleccionar al menos 1 portafolio.'});
      } else {
        console.log("Open Modal");
        this.setState({gen_report:true});
      }
    }
    async genReport(){
      // this.setState({generating_report:true});
      console.log("Generate report");
      if (this.props.compar_params.report_name==null || this.props.compar_params.report_name=="") {
        this.setState({msg_report:'Seleccionar reporte.'});
      } else {
        let saa;
        this.setState({
          generating_report:true,
          gen_report:false
        });
        try {
          saa = await postRequest({
            port_id:this.props.compar_params.port_names, 
            last_update:true,
            res_url:false,
            own_only:this.props.user_wm.data?.role==3 ? true : false,
            port_groups:this.props.user_wm.data?.port_groups
          }, 'port_saa');
        } catch(error) {
          this.setState({
            msg:`Error consultado portafolio (${error.message}).`,
            generating_report:false
          });
          return 
        }
        try {
          const resp = await postRequest(
            {
              ...this.props.compar_params, 
              per:this.props.compar_params.returns_period,
              weights_ports:saa.data.map(item=>{
                return {Portafolio:item.PortId, Activo:item.Asset, Peso:item.Weight}
              })
            }, 
            'reports_backtest_mult');
          this.setState({generating_report:false});
          if (resp.status=="ok"){
            window.location.replace(String(resp.url));
          }
        } catch(error) {
          this.setState({
            msg:`Error generando reporte (${error.message}).`,
            generating_report:false
          });
        }
      }
    }
  
    async runComparMetrics(){
      let result;
      if (this.props.compar_params.port_names.length==0) {
        this.setState({msg:'Seleccionar al menos 1 portafolio.'});
      } else {
        console.log("fetch!");
        const result = await this.props.fetchData(
          {
            ...this.props.compar_params,
            quant:0.99, 
            data_req_in_months:6,
            own_only:this.props.user_wm.data?.role==3 ? true : false,
            port_groups:this.props.user_wm.data?.port_groups
          }, 
          'port_metrics_mult', port_metrics_compar_actions);
        if (result.success){
          this.props.history.push(`/portfolio/compar/results`);          
        }
      }
    }
    
    render(){
        if(this.props.user_wm.isLogging){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Resumen de Portafolios</h4>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <Logging />
                </div>
              </div>
          );
        }else if(this.props.port_metrics_compar.isLoading){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Resumen de Portafolios</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                        <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                        <BreadcrumbItem><Link to='/portfolio/compar/results'>Resultados</Link></BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <CustomLoading msg="calculando métricas" icon="fa-calculator" />
                </div>
              </div>
          );
        } else {
            return(
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                      <div className="col-auto">
                          <h4>Resumen de Portafolios</h4>
                      </div>
                    </div>
                    <div className="row m-3 justify-content-center">
                      <div className="col-auto">
                        <Breadcrumb>
                            <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                            <BreadcrumbItem><Link to='/portfolio/compar/results'>Resultados</Link></BreadcrumbItem>
                        </Breadcrumb>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-6">
                        <Alert
                          color='secondary'
                          isOpen={this.state.msg!=='' && this.state.msg!==null} 
                          toggle={()=>this.setState({msg:null})}
                          fade={false}
                          >
                            {this.state.msg}
                        </Alert>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-9">
                            <ReduxForm model="compar_params">
                                {this.state.show_msg && this.props.port_metrics_compar.errMess!=='' && this.props.port_metrics_compar.errMess!==null ?
                                  <div className="row mt-4 justify-content-center">
                                    <div className="col-6 m-1">
                                      <Alert
                                        color={this.props.port_metrics_compar.errMess.includes('Error') ? 'danger':'secondary'}
                                        isOpen={this.state.show_msg && this.props.port_metrics_compar.errMess!=='' && this.props.port_metrics_compar.errMess!==null} 
                                        toggle={()=>this.setState({show_msg:false})}>
                                          {this.props.port_metrics_compar.errMess}
                                      </Alert>
                                    </div>
                                  </div>
                                  :<></>
                                }
                                <div className='row justify-content-center align-items-end m-4'>
                                  <div className='col-7'>
                                    <h6>Portafolios</h6>
                                    <CustomSelect
                                      className="basic-multi-select"
                                      options={this.props.user_wm.data.ports_list}
                                      value={this.props.compar_params.port_names.map(x=>{
                                        return {value:x, label:x};
                                      })}
                                      isClearable={true}
                                      isSearchable={true}
                                      onChange={(e)=>this.props.changeModel("compar_params.port_names", e.map(x=>x.value))}  
                                      placeholder="seleccionar portafolios..."
                                    />
                                  </div>
                                  {this.props.user_wm.data?.role==1 || this.props.user_wm?.data?.services.includes("query_database") ? 
                                    (this.state.loading_groups ?
                                      <div className='col-4'>
                                        <CustomLoading msg="grupos de portafolios"/>
                                      </div>
                                    : (this.props.port_groups!==null ?
                                        <div className='col-4'>
                                          <h6>Grupos</h6>
                                          <CustomListSelect
                                            options={unique_values(this.props.port_groups, 'GroupId').map(x=>{
                                              return {value:x, label:x};
                                            })}
                                            isClearable={true}
                                            value={this.props.compar_params.port_group==null ? null : {value:this.props.compar_params.port_group, label:this.props.compar_params.port_group}}
                                            onChange={(e)=>{
                                             this.props.changeModel("compar_params.port_group", e==null ? null : e.value);
                                             if (e!==null){
                                               this.props.changeModel("compar_params.port_names", this.props.port_groups.filter(k=>k.GroupId==e.value).map(k=>k.PortId));
                                             }
                                            }}
                                            itemSize={50}
                                            className="basic-single"
                                            placeholder="Seleccionar..."
                                          />
                                        </div>
                                        :
                                          <div className='col-4'>
                                            <Button className='link-btn'
                                              onClick={this.loadGroups}
                                            >
                                              actualizar grupos&darr;
                                            </Button>
                                          </div>
                                        )
                                    )
                                    :null
                                  }
                                </div>
                                <div className='row m-4 justify-content-center align-items-end'>
                                    <div className='col-2'>
                                        <h6>Moneda</h6>
                                        <Control.select 
                                            model=".ref_curr" 
                                            type="select" 
                                            name="ref_curr"
                                            className="form-control"
                                            disabled={false}
                                            >
                                            <option>USD</option>
                                            <option>CLP</option>
                                            <option>CLF</option>
                                            <option>MXN</option>
                                            <option>COP</option>
                                            <option>UVR</option>
                                            <option>PEN</option>
                                            <option>UYU</option>
                                        </Control.select>
                                    </div>
                                    <div className='col-3'>
                                        <h6>Fecha Inicial</h6>
                                        <Control.text model=".ini_date" type="date"
                                            name="ini_date"
                                            dafaultvalue="2011-01-01"
                                            dateform="YYYY-MM-DD"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={false}
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <h6>Fecha Final</h6>
                                        <Control.text model=".ref_date" type="date"
                                            name="ref_date"
                                            dateform="YYYY-MM-DD"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-4'>
                                    <div className='col-3'>
                                        <h6>Periodo Retornos</h6>
                                        <Control.select model=".returns_period" type="select" name="per"
                                            className="form-control">
                                            <option value="daily">Diario</option>
                                            <option value="monthly">Mensual</option>
                                            <option value="quarterly">Trimestral</option>
                                        </Control.select>
                                    </div>
                                    <div className='col-3'>
                                        <h6>Periodo Rebalanceo</h6>
                                        <Control.select model=".rebal_period" type="select" name="rebal_period"
                                            className="form-control">
                                            <option value="monthly">Mensual</option>
                                            <option value="quarterly">Trimestral</option>
                                            <option value="yearly">Anual</option>
                                        </Control.select>
                                    </div>
                                </div>
                                <div className="row justify-content-center mt-5">
                                    <div className='col-auto'>
                                        <Button 
                                            className="btn-corp"
                                            onClick={this.runComparMetrics}>
                                            Cálcular Métricas
                                        </Button>
                                    </div>
                                    {this.state.generating_report ?
                                      <div className='col-2'>
                                        <CustomLoading mt="0" msg="Generando Reporte. Por favor no salgas de esta página" />
                                      </div>
                                    : 
                                      <div className='col-auto'>
                                          <Button 
                                              className="btn-corp"
                                              onClick={this.openReportModal}>
                                              Generar Reporte
                                          </Button>
                                      </div>
                                    }
                                    {this.state.loading_allocation ?
                                      <div className='col-2'>
                                        <CustomLoading mt="0" msg="Cargando allocation. Por favor no salgas de esta página" />
                                      </div>
                                    : 
                                      <div className='col-auto'>
                                          <Button 
                                              className="btn-corp"
                                              onClick={this.queryAllocation}>
                                              Ver Allocation
                                          </Button>
                                      </div>
                                    }
                                </div>
                            </ReduxForm>
                            <Modal isOpen={this.state.gen_report} toggle={()=>this.setState({gen_report:!this.state.gen_report})}>
                              <ModalHeader toggle={()=>this.setState({gen_report:!this.state.gen_report})}>Generar Reporte</ModalHeader>
                              <ModalBody>
                                  <div className="row m-4 justify-content-center">
                                    <div className="col-8 m-1">
                                      <CustomListSelect
                                        maxMenuHeight={150}
                                        options={[
                                          {value:"Delta", label:"Reporte Delta"},
                                          {value:"Riesgo", label:"Reporte de Riesgo"},
                                          {value:"Reporte Perú WM", label:"Reporte WM"}
                                          ]}
                                        isClearable={true}
                                        value={this.props.compar_params.report_name!=null ? {value:this.props.compar_params.report_name, label:this.props.compar_params.report_name} : null}
                                        onChange={(e)=>this.props.changeModel("compar_params.report_name", e?.value)}
                                        itemSize={50}
                                        className="basic-single"
                                        placeholder="Seleccionar..."
                                      />
                                    </div>
                                  </div>
                                  <div className="row m-1 justify-content-center">
                                    <div className="col-auto m-1">
                                      <Button 
                                        className="btn-corp"
                                        onClick={this.genReport}
                                        >
                                          Descargar reporte
                                      </Button>
                                    </div>
                                  </div>
                                  <div className="row mt-4 justify-content-center">
                                    <div className="col-6">
                                      <Alert
                                        color='secondary'
                                        isOpen={this.state.msg_report!=='' && this.state.msg_report!==null} 
                                        toggle={()=>this.setState({msg_report:null})}>
                                          {this.state.msg_report}
                                      </Alert>
                                    </div>
                                  </div>
                              </ModalBody>  
                            </Modal>
                        </div>
                    </div>
                    {this.props.port_alloc_compar ?
                    <>
                      <div className='row justify-content-center align-items-end m-5'>
                        <div className='col'>
                          <hr></hr>
                        </div>
                      </div>

                      <div className='row justify-content-center align-items-end mt-5'>
                          <div className='col-3'>
                            <h6>Portafolio</h6>
                            <CustomListSelect
                              options={unique_values(this.props.port_alloc_compar, 'PortId').map(x=>{
                                return {value:x, label:x};
                              })}
                              isClearable={true}
                              value={this.props.compar_params.port_alloc_name==null ? null : {value:this.props.compar_params.port_alloc_name, label:this.props.compar_params.port_alloc_name}}
                              onChange={(e)=>{this.props.changeModel("compar_params.port_alloc_name", e==null ? null : e.value)}}
                              itemSize={50}
                              className="basic-single"
                              placeholder="Seleccionar..."
                            />
                          </div>
                          <div className='col-2'>
                            <h6>Fecha</h6>
                            <CustomListSelect
                              options={unique_values(this.props.port_alloc_compar.filter(k=>k.PortId==this.props.compar_params.port_alloc_name), 'DatePort').map(x=>{
                                return {value:x, label:x};
                              })}
                              isClearable={true}
                              value={this.props.compar_params.port_alloc_date==null ? null : {value:this.props.compar_params.port_alloc_date, label:this.props.compar_params.port_alloc_date}}
                              onChange={(e)=>{this.props.changeModel("compar_params.port_alloc_date", e==null ? null : e.value)}}
                              itemSize={50}
                              className="basic-single"
                              placeholder="Seleccionar..."
                            />
                          </div>
                      </div>
                      {this.props.port_alloc_compar.filter(k=>k.PortId==this.props.compar_params.port_alloc_name && k.DatePort==this.props.compar_params.port_alloc_date).length>0 ?
                      <div className='row justify-content-center align-items-center mt-4'>
                          <div className='col-6'>
                            <div className="row justify-content-center">
                              <div className='col-auto'>
                                <RenderVirtualTable 
                                  data={this.props.port_alloc_compar.filter(k=>k.PortId==this.props.compar_params.port_alloc_name && k.DatePort==this.props.compar_params.port_alloc_date).map(k=>{
                                    return {Activo:k.Asset , Peso:k.Weight*100};
                                  }).sort(sort_by("Peso", "desc"))} 
                                  to_perc={[false, true]}
                                  cell_width={['250px', "150px"]}
                                  item_size={40}
                                  style="black"
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col'>
                                <CSVLink className='link-btn' data={this.props.port_alloc_compar.filter(k=>k.PortId==this.props.compar_params.port_alloc_name)} filename="allocation"><small>Descargar allocation&darr;</small></CSVLink>
                              </div>
                            </div>
                          </div>
                          <div className='col-6'>
                            <PiePlot 
                              data={this.props.port_alloc_compar.filter(k=>k.PortId==this.props.compar_params.port_alloc_name && k.DatePort==this.props.compar_params.port_alloc_date).map(k=>{
                                return {name:k.Asset , value:k.Weight*100};
                              }).sort(sort_by("value", "desc"))} 
                              legend={true}
                              percTooltip={true}
                              legendHeight={150}
                              width={550}
                              height={500}
                              outerRadius={100}
                              dataKey="value"
                              nameKey="name"
                            />
                          </div>
                      </div>
                      :null
                      }
                    </>
                    : null
                    }
                </div>
            );
        }
    }
}

export default withRouter(connect(mapStateToProps)(PortCompar));
